import {
	configurePaymentMethodV2,
	ConfigurePaymentMethodV2Schema,
} from "@indebted/api/paymentArrangement/configurePaymentMethodV2"
import type {NavigateFunction} from "react-router"

export async function configurePaymentMethodOnSuccess({
	PaymentArrangementID,
	PaymentMethodID,
	ProviderSetupID,
	ProviderRawData,
}: {
	PaymentArrangementID: string
	PaymentMethodID: string
	ProviderSetupID: string
	ProviderRawData: unknown
	navigate: NavigateFunction
}): Promise<string> {
	const configureParams = {
		PaymentArrangementID: PaymentArrangementID,
		PaymentMethodID: PaymentMethodID,
		SetupIntentID: ProviderSetupID,
		ProviderRawData: JSON.stringify(ProviderRawData),
	}

	const configurePaymentMethodResponse = await configurePaymentMethodV2(
		ConfigurePaymentMethodV2Schema.parse(configureParams),
	)

	return configurePaymentMethodResponse.Next
}
